import { RECENT_ADD_ITEM, RECENT_REMOVE_ITEM } from "../actions/recent-items";

const defaultState = [];

export function recentItems(state = defaultState, action) {
    switch (action.type) {
        case RECENT_ADD_ITEM:
            // concat returns a new array, which is what we want
            if (state.find((item) => item.uuid === action.payload.item.uuid)) {
                return state;
            }
            return [action.payload.item].concat(state);
        case RECENT_REMOVE_ITEM:
            return state.filter(
                (item) => item.uuid !== action.payload.item.uuid
            );
        default:
            return state;
    }
}
